import { defineComponent, openBlock, createElementBlock, createElementVNode, createVNode, unref, withCtx, createTextVNode } from "vue";
import { CdrLink } from "@rei/cedar";
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "PreorderModal",
  props: {
    preOrderFaqLink: {}
  },
  setup(__props) {
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", null, [_cache[1] || (_cache[1] = createElementVNode("p", null, " Most pre-order items ship within 30 days or less. We'll ship your pre-order as soon as it gets to our distribution center—before it hits stores. Please note that manufacturers tell us when we can expect to receive the product. However, it is an estimate, and ship dates are subject to change. ", -1)), _cache[2] || (_cache[2] = createElementVNode("p", null, " With pre-ordered items, you can cancel your order any time before it ships. ", -1)), _cache[3] || (_cache[3] = createElementVNode("p", null, " Yes, REI Co-op Members earn a Co-op Member Reward on eligible pre-orders! ", -1)), createVNode(unref(CdrLink), {
        class: "pre-order-faq-link",
        modifier: "standalone",
        href: _ctx.preOrderFaqLink
      }, {
        default: withCtx(() => _cache[0] || (_cache[0] = [createTextVNode(" See our pre-order FAQ ")])),
        _: 1,
        __: [0]
      }, 8, ["href"])]);
    };
  }
});
export {
  _sfc_main as default
};
//# sourceMappingURL=PreorderModal2.mjs.map
